import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const Container = styled(Box).attrs({
  position: 'relative',
  padding: '16px',
  backgroundColor: 'background',
  borderRadius: 5,
})`
  box-shadow: ${({ theme }) => `0px 4px 4px ${theme.colors.boxShadow}`};
`;

export const Title = styled(Text).attrs({
  marginBottom: 32,
  color: 'secondaryText',
  size: 'xlarge',
  fontWeight: 'semibold',
})``;
